import React from 'react';
import { useIntl, IntlShape } from 'react-intl';

interface WithIntlProps {
  render: (intl: IntlShape) => React.ReactElement;
}

const WithIntl = ({ render }: WithIntlProps): React.ReactElement => {
  const intl = useIntl();
  return render(intl);
};

export default WithIntl;
